import React, { forwardRef } from 'react';
import { Divider, DividerProps, Stack, StackProps } from '@mui/material';

type StackWithDividerProps = {
  dividerProps?: DividerProps;
} & Omit<StackProps, 'divider'>;

const StackWithDivider = forwardRef<any, StackWithDividerProps>(
  (props: StackWithDividerProps, ref) => {
    const {
      dividerProps,
      children,
      direction = 'column',
      ...stackProps
    } = props;
    return (
      <Stack
        ref={ref}
        direction={direction}
        divider={
          <Divider
            orientation={
              direction === 'row' || direction === 'row-reverse'
                ? 'vertical'
                : 'horizontal'
            }
            {...dividerProps}
            flexItem
          />
        }
        {...stackProps}
      >
        {children}
      </Stack>
    );
  },
);
StackWithDivider.displayName = 'StackWithDivider';

export default StackWithDivider;
